import React from "react";

// Background image
import serviceBg from "../../images/bg/service-gradient-bg.png";

// Service images
import img07 from "../../images/service/video.png";
import img08 from "../../images/service/Foto.png";
import img09 from "../../images/service/postp.png";

const ServiceSection: React.FC = () => {
  // ========================
  // ARRAY DATA
  // ========================
  const services = [
    {
      title: "Producción de video",
      content:
        "Creamos producciones que elevan marcas, capturan atención y transmiten experiencias visuales impactantes.",
      images: [img07, img07, img07, img07],
    },
    {
      title: "Servicio de fotografía.",
      content:
        "Creamos fotografía profesional para eventos, asociaciones y marcas que buscan transmitir identidad y presencia.",
      images: [img08, img08, img08, img08],
    },
    {
      title: "Postproducción",
      content:
        "Transformamos material audiovisual en piezas impactantes mediante edición, color y postproducción diseñada para destacar marcas.",
      images: [img09, img09, img09, img09],
    },
  ];

  // ========================
  // RETURN SECTION
  // ========================
  return (
    <section
      className="service pos-rel bg_img"
      style={{ backgroundImage: `url(${serviceBg})` }}
    >
      <div className="container">
        <div className="row mt-none-30">
          {services.map((service, index) => (
            <div className="col-lg-4 mt-30" key={index}>
              <div className="xb-ser-item xb-border img-hove-effect">
                <div className="xb-item--inner">
                  <h3 className="xb-item--title border-effect">{service.title}</h3>

                  <p className="xb-item--content">{service.content}</p>

                  <div className="xb-item--img xb-img">
                    {service.images.map((img, i) => (
                      <span className="xb-service-static-img" key={i}>
                        <img src={img} alt={service.title} />
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
